/* eslint-disable react/forbid-elements */
import { RichTextEditor, useRichTextEditorContext } from '@mantine/tiptap';
import React from 'react';
import {
    MarkdownEditorAddColumnAfterIcon,
    MarkdownEditorAddColumnBeforeIcon,
    MarkdownEditorAddRowAfterIcon,
    MarkdownEditorAddRowBeforeIcon,
    MarkdownEditorAddTableIcon,
    MarkdownEditorRemoveColumnIcon,
    MarkdownEditorRemoveRowIcon,
    MarkdownEditorRemoveTableIcon,
} from './markdownEditorIcons';

export function MarkdownEditorAddTableButton() {
    const { editor } = useRichTextEditorContext();

    return (
        <RichTextEditor.Control
            onClick={() => editor!.chain().focus().insertTable({ rows: 1, cols: 1 }).run()}
            aria-label="Insert table"
            title="Insert table"
        >
            <MarkdownEditorAddTableIcon />
        </RichTextEditor.Control>
    );
}

export function MarkdownEditorRemoveTableButton() {
    const { editor } = useRichTextEditorContext();

    return (
        <button
            className="richTextEditorControlButton"
            data-rich-text-editor-control="true"
            tabIndex={0}
            data-interactive="true"
            type="button"
            onClick={() => editor!.chain().focus().deleteTable().run()}
        >
            <MarkdownEditorRemoveTableIcon />
        </button>
    );
}

export function MarkdownEditorAddRowBefore() {
    const { editor } = useRichTextEditorContext();

    return (
        <RichTextEditor.Control onClick={() => editor!.chain().focus().addRowBefore().run()}>
            <MarkdownEditorAddRowBeforeIcon />
        </RichTextEditor.Control>
    );
}

export function MarkdownEditorAddRowAfter() {
    const { editor } = useRichTextEditorContext();

    return (
        <RichTextEditor.Control onClick={() => editor!.chain().focus().addRowAfter().run()}>
            <MarkdownEditorAddRowAfterIcon />
        </RichTextEditor.Control>
    );
}

export function MarkdownEditorAddColumnBefore() {
    const { editor } = useRichTextEditorContext();

    return (
        <RichTextEditor.Control onClick={() => editor!.chain().focus().addColumnBefore().run()}>
            <MarkdownEditorAddColumnBeforeIcon />
        </RichTextEditor.Control>
    );
}

export function MarkdownEditorAddColumnAfter() {
    const { editor } = useRichTextEditorContext();

    return (
        <RichTextEditor.Control onClick={() => editor!.chain().focus().addColumnAfter().run()}>
            <MarkdownEditorAddColumnAfterIcon />
        </RichTextEditor.Control>
    );
}

export function MarkdownEditorRemoveColumn() {
    const { editor } = useRichTextEditorContext();

    return (
        <RichTextEditor.Control onClick={() => editor!.chain().focus().deleteColumn().run()}>
            <MarkdownEditorRemoveColumnIcon />
        </RichTextEditor.Control>
    );
}

export function MarkdownEditorRemoveRow() {
    const { editor } = useRichTextEditorContext();

    return (
        <RichTextEditor.Control onClick={() => editor!.chain().focus().deleteRow().run()}>
            <MarkdownEditorRemoveRowIcon />
        </RichTextEditor.Control>
    );
}
